import {
  handleWithErrorMessage,
  handleWithGlobalMessage
} from "@/services/utils";
import api from "@/services/modules/users/qualifications";
import {
  SET_IS_FETCHING_USER_QUALIFICATIONS,
  SET_CURRENT_USER_QUALIFICATIONS
} from "@/store/modules/users/qualifications/mutations";
import { filter, map } from "lodash";

export const FETCH_USER_QUALIFICATIONS = "FETCH_USER_QUALIFICATIONS";
export const REMOVE_USER_QUALIFICATION = "REMOVE_USER_QUALIFICATION";
export const ADD_USER_QUALIFICATION = "ADD_USER_QUALIFICATION";
export const EDIT_USER_QUALIFICATION = "EDIT_USER_QUALIFICATION";
export const FETCH_USER_BOOKING_QUALIFICATIONS =
  "FETCH_USER_BOOKING_QUALIFICATIONS";

const actions = {
  async [FETCH_USER_QUALIFICATIONS]({ commit, dispatch }, userId) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api(commit).getUserQualifications(userId),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_USER_QUALIFICATIONS, isLoading),
      setDataFunction: ({ data }) =>
        commit(SET_CURRENT_USER_QUALIFICATIONS, data)
    });
  },
  async [FETCH_USER_BOOKING_QUALIFICATIONS](
    { commit, dispatch },
    { userId, bookingId }
  ) {
    return handleWithErrorMessage({
      dispatch,
      request: () =>
        api(commit).getUserBookingQualifications({ userId, bookingId }),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_USER_QUALIFICATIONS, isLoading),
      setDataFunction: ({ data }) =>
        commit(SET_CURRENT_USER_QUALIFICATIONS, data)
    });
  },
  async [ADD_USER_QUALIFICATION]({ commit, dispatch, state }, qualification) {
    const { data: newQualification } = await handleWithGlobalMessage(
      () => api(commit).addUserQualification(qualification),
      dispatch
    );
    const currentQualifications = state.currentUserQualifications;
    const newQualifications = [...currentQualifications, newQualification];
    commit(SET_CURRENT_USER_QUALIFICATIONS, newQualifications);
  },
  async [EDIT_USER_QUALIFICATION]({ commit, dispatch, state }, qualification) {
    const { data: updatedQualification } = await handleWithGlobalMessage(
      () => api(commit).editUserQualification(qualification),
      dispatch
    );
    const updatedQualifications = map(
      state.currentUserQualifications,
      qualification => {
        if (qualification.id !== updatedQualification.id) return qualification;
        return updatedQualification;
      }
    );
    commit(SET_CURRENT_USER_QUALIFICATIONS, updatedQualifications);
  },
  async [REMOVE_USER_QUALIFICATION](
    { commit, dispatch, state },
    qualificationId
  ) {
    await handleWithGlobalMessage(
      () => api(commit).removeUserQualification(qualificationId),
      dispatch
    );
    const currentQualifications = state.currentUserQualifications;
    const newQualifications = filter(
      currentQualifications,
      ({ id }) => id !== qualificationId
    );
    commit(SET_CURRENT_USER_QUALIFICATIONS, newQualifications);
  }
};

export default actions;
